// extracted by mini-css-extract-plugin
export var wordContainer = "_nc-0";